/*
 * @Author: shiguang
 * @Date: 2023-07-07 18:02:47
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-07 10:38:38
 * @Description: ROUTER_BASENAME
 */
export const ROUTER_BASENAME = '/';
